/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import React, { useContext, useCallback, useState, useEffect } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import RepairsOrAdditions from '../RepairsOrAdditions/RepairsOrAdditions';
import metadata from './TWIARepairsOrAdditionsComponent.metadata.json5';
import TWIADateFormatUtil from '../../../util/TWIADateFormatUtil';
import styles from '../Construction.module.scss';
import messages from '../Construction.messages';

import { Button } from '@jutro/legacy/components';

function TWIARepairsOrAdditionsComponent(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate, selectedBuilding, isCommercial } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [showRepairDetails, updateShowRepairDetails] = useState(false);
    const [repairDetailsVM, updateRepairDetailsVM] = useState();
    const [checkbox, setCheckBox] = useState(false);
    const [repairData, setRepairData] = useState([]);
    const [editRowIndex, setEditRowIndex] = useState(null);
    const { refreshData } = useDataRefresh();
    const { showAlert, showConfirm } = useModal();
    const intl = useContext(IntlContext);
   
    const policyTypeCode = isCommercial ? '':submissionVM.lobData.homeowners.policyType_TWIA.value.code;

    // Commercial Property
    const coverageFormCode = isCommercial ? selectedBuilding?.coverageForm.value.code : '';

    const repairExists = isCommercial 
    ? true
    : _.get(submissionVM.value, 'lobData.homeowners.coverables.construction.repairsOrAdditions_TWIA');
    
    const repairTableData = isCommercial ? 
            selectedBuilding.construction_TWIA?.repairAdditionsDTO_TWIA?.value :
            _.get(submissionVM.value, 'lobData.homeowners.coverables.construction.repairAdditionsDTO_TWIA');


    const addRepairDetailsBox = useCallback(() => {
        const update = viewModelService.create(
            {},
            'pc',
            'org.twia.edge.capabilities.policyjob.lob.homeowners.coverables.dto.TWIAHODwellingRepairDtlsDTO'
        );
        updateRepairDetailsVM(update);
        updateShowRepairDetails(true);
        setEditRowIndex(null);
    }, [viewModelService]);

    const writeValue = useCallback(
        (value, path) => {
            if (!isCommercial){ // only for Personal Lines
                if (path === 'lobData.homeowners.coverables.construction.repairsOrAdditions_TWIA'){
                    setCheckBox(value);
                    _.set(submissionVM, path, value);
                    updateWizardData(submissionVM);

                    if (!value && repairData.length > 0) {
                        showAlert({ // DE18620
                            title: messages.repairAlert,
                            message: messages.repairAlertMessage,
                            status: 'warning',
                            icon: 'mi-error-outline',
                            confirmButtonText: messages.closeModal,
                        }).then((results) => {
                            if (results === 'cancel' || results === 'close') {
                                 // DE15535
                                setCheckBox(true);
                                _.set(submissionVM, path, !value);
                                updateWizardData(submissionVM);
                            }
                            setCheckBox(true);
                            _.set(submissionVM, path, !value);
                            updateWizardData(submissionVM);
                            return true;
                        })
                    }
                }
                _.set(submissionVM, path, value);
                updateWizardData(submissionVM);

                if (!value && repairData.length > 0) {
                    showAlert({
                        title: messages.repairAlert,
                        message: messages.repairAlertMessage,
                        status: 'warning',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.closeModal,
                    }).then((results) => {
                        if (results === 'cancel' || results === 'close') {
                            // DE15535
                            setCheckBox(true);
                            _.set(submissionVM, path, !value);
                            updateWizardData(submissionVM);
                        }
                        setCheckBox(true);
                        _.set(submissionVM, path, !value);
                        updateWizardData(submissionVM);
                        return true;
                    })
                }
            }
        }, [refreshData, repairData?.length, showAlert, submissionVM, updateWizardData]
    );

   const updateRepairs = ((updateRepairData) =>{
        if (isCommercial){ 
            selectedBuilding.construction_TWIA.repairAdditionsDTO_TWIA = updateRepairData;
        }
        else {
            _.get(submissionVM.value, 'lobData.homeowners.coverables.construction').repairAdditionsDTO_TWIA = updateRepairData;
        }
    });

    const saveRepairUpdates = (updatedData) => {
        if (editRowIndex !== null) {
            const updatedRepairData = repairData.map((item, index) => index === editRowIndex ? updatedData : item);
            setRepairData(updatedRepairData);
            updateRepairDetailsVM(updatedRepairData);
            updateRepairs(updatedRepairData);
            updateWizardData(submissionVM);
            setEditRowIndex(null);
        } else {
            const newItem = [...repairData, updatedData.value];
            setRepairData(newItem);
            updateRepairDetailsVM(newItem);
            updateRepairs(newItem);
            updateWizardData(submissionVM);
        }
        updateShowRepairDetails(false);
    };

    let oldVMData = [];
    
    const editRow = (index) => {
        oldVMData = _.clone(repairData[index]);
        setEditRowIndex(index);
        updateRepairDetailsVM(oldVMData);
        updateShowRepairDetails(true);
    };

    const deleteRow = (index) => {
        showConfirm({
            // DE15465
            title: messages.wantToDeleteRepair,
            message: messages.repairCancelMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.yesModal,
            cancelButtonText: messages.noModal, // DE17089
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            const updatedRepairData = repairData.filter((_, i) => i !== index);
            setRepairData(updatedRepairData);
            updateRepairs(updatedRepairData)
            updateWizardData(submissionVM);
            return true;
        }, _.noop)
    };

    const cancelRepairUpdates = () => {
        updateRepairDetailsVM(oldVMData);
        updateShowRepairDetails(false);
    };

    const getDate = (item) => {
        if (!item || !item.repairDate) {
            return 'Invalid Date';
        }
        return TWIADateFormatUtil.formatDate(item.repairDate);
    };

    const getDescription = (item) => item.repairDesc;

    const getCertificate = (item) => {
        if (item.repairDate.year < 1988) {
            return '';
        }
        return item.hasWPI8CertOfCompIssued_TWIA === true ? 'Yes' : 'No'; }

    const actionButtons = (row, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-delete"
                onClick={() => deleteRow(index)}
                aria-label="Delete Row"
            />
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-edit"
                onClick={() => editRow(index)}
                aria-label="Edit Row"
            />
        </div>
    );

    useEffect(() => {   
        setCheckBox(false);
        if (repairExists !== undefined && repairExists) {
            setCheckBox(true);
            setRepairData(repairTableData);
        } 
    }, []);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        repairsAdditionsMainContainer: {
            visible: checkbox
        },
        repairsOrAddsSection: {
            visible: showRepairDetails,
            item: repairDetailsVM,
            saveData: saveRepairUpdates,
            cancelData: cancelRepairUpdates,
            isInvalid: findInvalidComponent,
            showErrors,
        },
        repairsUpdatesTable: {
            data: repairData
        },
        addButtonId: {
            visible: !showRepairDetails,
            onClick: addRepairDetailsBox
        },
        repairsUpdates: {
            required: checkbox,
            showRequired: checkbox,
            // label change for Manufactured Home
            label: policyTypeCode === 'TWRM' ? translator(messages.repairsMH) : translator(messages.repairs),
            showRequired: checkbox,
            visible : !isCommercial
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addRepairDetailsBox,
            getDate,
            getDescription,
            getCertificate,
            actionButtons
        },
        resolveComponentMap: { repairsOrAdds: RepairsOrAdditions }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            showErrors={showErrors}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )
}

export default TWIARepairsOrAdditionsComponent